import { AiOutlineInfoCircle } from "react-icons/all";
import { Tooltip } from "@chakra-ui/react";

import { Icon } from "components/Icon";
import { IconButton, IconButtonProps } from "components/IconButton";

interface IProps extends Omit<IconButtonProps, "aria-label"> {
  appointmentId: string;
}

const CancelReasonAppointmentButton = ({ appointmentId, ...props }: IProps) => {
  const cancelReasonMessage = "Przyczyna anulowania";
  return (
    <Tooltip label={cancelReasonMessage} aria-label={cancelReasonMessage}>
      <IconButton
        id={`cancel-reason-appointment-${appointmentId}-icon-btn`}
        background="transparent"
        icon={<Icon w={5} h={5} color="black.900" icon={AiOutlineInfoCircle} />}
        {...props}
        aria-label={cancelReasonMessage}
      />
    </Tooltip>
  );
};

export { CancelReasonAppointmentButton };
